module.exports = __webpack_public_path__ + "static/img/til35.6b29bfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/til35.png
// module id = i/u/
// module chunks = 1